import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31084f78"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"padding-left":"35px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-loading",
  style: {"color":"#2196f3"}
}, null, -1 /* HOISTED */))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  style: {"padding-left":"1px"}
}
const _hoisted_5 = { style: {"color":"#444","font-size":"13px","letter-spacing":"0.8px"} }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_category_tree = _resolveComponent("category-tree", true)!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", {
      class: _normalizeClass({ 'not_root': $props.level>0, 'cat_box': true ,'amazon__lists':$props.level==0})
    }, [
      (($options.filteredCategories.length === 0 && $data.loading === true && $props.level>0))
        ? (_openBlock(), _createElementBlock("li", _hoisted_1, _hoisted_3))
        : _createCommentVNode("v-if", true),
      (($options.filteredCategories.length === 0 && $data.loading === false && $props.level>0))
        ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
            _createElementVNode("p", null, [
              _createElementVNode("label", _hoisted_5, [
                _createVNode(_component_Checkbox, {
                  checked: "",
                  disabled: true
                }),
                _createTextVNode(" Empty ")
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredCategories, (cat) => {
        return (_openBlock(), _createElementBlock("li", {
          onClick: ($event: any) => ($options.handleClick($event, cat)),
          key: cat.id,
          class: _normalizeClass((cat.has_children === false ? 'no__children': ''))
        }, [
          _createElementVNode("p", {
            class: _normalizeClass($options.getClasses(cat.id))
          }, [
            _createElementVNode("label", {
              style: _normalizeStyle('cursor: pointer; margin-bottom: 0;' + (cat.has_children === false ? 'margin-left: 25px': ''))
            }, [
              (cat.has_children === true)
                ? (_openBlock(), _createBlock(_component_Checkbox, {
                    key: 0,
                    checked: $options.isAddedAsFilter(cat.id)
                  }, null, 8 /* PROPS */, ["checked"]))
                : _createCommentVNode("v-if", true),
              _createTextVNode(" " + _toDisplayString(cat.category_name), 1 /* TEXT */)
            ], 4 /* STYLE */)
          ], 2 /* CLASS */),
          ($options.isAddedAsFilter(cat.id))
            ? (_openBlock(), _createBlock(_component_category_tree, {
                key: 0,
                id: cat.id,
                level: $props.level+1,
                searchResultsPaths: $props.searchResultsPaths,
                marketplaceId: $props.marketplaceId,
                categoryTreeCheckAction: $props.categoryTreeCheckAction
              }, null, 8 /* PROPS */, ["id", "level", "searchResultsPaths", "marketplaceId", "categoryTreeCheckAction"]))
            : _createCommentVNode("v-if", true)
        ], 10 /* CLASS, PROPS */, _hoisted_6))
      }), 128 /* KEYED_FRAGMENT */))
    ], 2 /* CLASS */),
    ($props.level==0 && $options.filteredCategories.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, " No categories found. "))
      : _createCommentVNode("v-if", true)
  ]))
}